import FilledButtonM from "@common/components/button/FilledButtonM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { useInterval } from "@common/utils/useInterval"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setVideoRecord } from "@data/redux/actions/camera"
import { tutorsService } from "@data/services/tutorsService"
import { useNavigation } from "@react-navigation/native"
import { useVideoPlayer, VideoView } from "expo-video"
import moment from "moment"
import React, { useContext, useEffect, useState } from "react"
import { ScrollView, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import { connect } from "react-redux"
import { useRequestsBatch } from "../../../common/hooks/useRequestsBatch"
import TodoModal from "../../../student/activity/todo/TodoModal"

const InterviewQuestion = (props) => {
    const { field, canFinish, tooLate, callBackOnSubmit } = props

    const questionId = field?.name?.split("_")?.[1]
    const question = props.testQuestions?.find(
        (q) => q?.id === parseInt(questionId)
    )
    const navigation = useNavigation()
    const dimensions = useContext(DimensionsContext)
    const answer = props.testAnswers?.find(
        (answer) => answer?.application_question_id === parseInt(questionId)
    )

    // Source resolved as a plain string so the player isn't recreated on every
    // render (passing a fresh { uri } object would re-instantiate it each time).
    const videoUri = answer?.answer?.startsWith("video_tmp:")
        ? props.videoRecord?.uri
        : answer?.video
    const player = useVideoPlayer(videoUri || null)

    const [reflectionDuration, setReflectionDuration] = useState(
        Math.max(
            question?.reflection_duration -
                Math.min(
                    answer?.viewed_at
                        ? moment().diff(answer?.viewed_at, "seconds")
                        : 0,
                    question?.reflection_duration - 1
                ),
            0
        )
    )

    const startVideoRecording = () => {
        if (answer?.video) {
            return
        }

        if (reflectionDuration > 0) {
            setReflectionDuration(0)
        } else {
            navigation?.push("video-recording", {
                questionId: questionId,
                testCategory: question?.category,
            })
        }
    }

    useEffect(() => {
        props.setVideoRecord(null)

        if (!answer) {
            props.apiRequest(tutorsService.submitQuestionViewed, {
                id: questionId,
            })
        }
    }, [])

    useEffect(() => {
        if (reflectionDuration <= 0 && !answer?.video)
            navigation?.push("video-recording", {
                questionId: questionId,
                testCategory: question?.category,
            })
    }, [reflectionDuration])

    useInterval(
        () => {
            setReflectionDuration((p) => p - 1)
        },
        reflectionDuration > 0 && !answer?.video && !(answer && tooLate)
            ? 1000
            : null
    )

    const videoFile = IS_WEB
        ? props.videoRecord
        : {
              uri: props.videoRecord?.uri,
              name: `Masteur_Video_${
                  props.user?.display_name
              }_${moment().format("YYYY-MM-DD")}.mp4`,
              type: "video/mp4",
          }
    const filesToUpload = [videoFile]

    const [globalProgress, submitted, startRequests] = useRequestsBatch(
        [],
        filesToUpload,
        "APPLICATION_FORM",
        {
            service: tutorsService.submitTestVideo,
            data: {},
            tmpFilesKey: "video",
            tmpFilesFormatter: (attachmentTmp) => {
                return attachmentTmp
            },
            additionalData: [],
            params: { id: questionId },
            onSuccessBeforeNext: () => {},
        },
        [],
        false
    )

    useEffect(() => {
        setTimeout(() => {
            if (!answer?.video && props.videoRecord) {
                startRequests()
            }
        }, 700)
    }, [props.videoRecord])

    const submitAnswer = () => {
        props.setVideoRecord(null)
        callBackOnSubmit()
    }

    return (
        <View
            style={{
                flex: 1,
                marginTop: 10,
            }}
        >
            <ScrollView
                style={{ flex: 1 }}
                contentContainerStyle={{
                    alignItems: "center",
                    justifyContent: "flex-start",
                    width: dimensions?.width,
                }}
            >
                {submitted ? (
                    <>
                        <ActivityIndicator
                            animating={true}
                            style={{
                                alignSelf: "center",
                                justifySelf: "center",
                                marginBottom: 10,
                            }}
                            size="large"
                            color={theme.colors.primary}
                        />
                        <TextM style={{ textAlign: "center" }} wrap>
                            Envoi de la vidéo en cours...
                        </TextM>
                        <TextM
                            style={{ textAlign: "center" }}
                            fontWeight={"Bold"}
                            wrap
                        >
                            {globalProgress}%
                        </TextM>
                    </>
                ) : answer?.video ||
                  answer?.answer?.startsWith("video_tmp:") ? (
                    <View
                        style={{
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "flex-start",
                        }}
                    >
                        <VideoView
                            player={player}
                            style={{
                                position: "relative",
                                width: dimensions?.width,
                                height: dimensions?.height / 2,
                                marginTop: 20,
                                alignSelf: "center",
                            }}
                            nativeControls
                            contentFit="contain"
                        />
                    </View>
                ) : !!answer && tooLate ? (
                    <TextM
                        wrap
                        style={{ marginHorizontal: 10, textAlign: "center" }}
                    >
                        Pas de vidéo. Comme tu as déjà vu cette question, passe
                        à la suite.
                    </TextM>
                ) : (
                    <>
                        <View
                            style={{
                                flexDirection: IS_WEB ? "row" : "column",
                                alignItems: "center",
                                gap: 3,
                            }}
                        >
                            <TextM
                                color={theme.colors.primary}
                                fontWeight={"Bold"}
                                style={{ textAlign: "center", marginRight: 10 }}
                                fontSize={15}
                                wrap
                            >
                                L&apos;enregistrement vidéo va commencer dans
                            </TextM>
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                <TextM
                                    color={theme.colors.primary}
                                    fontSize={20}
                                    fontWeight={"Bold"}
                                    style={{
                                        marginRight: 5,
                                    }}
                                >
                                    {Math.floor(reflectionDuration / 60)}min
                                    {reflectionDuration % 60}s
                                </TextM>
                            </View>
                        </View>
                        <TextM
                            color={theme.colors.error}
                            wrap
                            style={{
                                marginVertical: 10,
                                textAlign: "center",
                            }}
                            fontWeight={"Light"}
                            fontSize={14}
                        >
                            Attention, si tu quittes cet écran, c&apos;est comme
                            si tu avais passé la question.
                        </TextM>
                        {question?.category === "technical" &&
                            question?.activity && (
                                <TodoModal
                                    item={question?.activity}
                                    isOpen={false}
                                    noModal
                                    interviewMode
                                    width={dimensions?.width - 20}
                                    height={dimensions?.height * 0.5}
                                />
                            )}
                    </>
                )}
            </ScrollView>

            {!submitted && (
                <View
                    style={{
                        alignItems: "center",
                    }}
                >
                    <FilledButtonM
                        label={canFinish ? "Terminer" : "Commencer"}
                        color={
                            canFinish
                                ? theme.colors.success
                                : theme.colors.primary
                        }
                        onPress={canFinish ? submitAnswer : startVideoRecording}
                    />
                </View>
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        testQuestions: state.data.tutors?.testQuestions,
        testAnswers: state.data.tutors?.testAnswers,
        videoRecord: state.camera?.videoRecord,
        submitTestAnswerRequest: state.api.submitTestVideo?.request,
        submitTestAnswerSuccess: state.api.submitTestVideo?.success,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setVideoRecord,
}

export default connect(mapStateToProps, mapDispatchToProps)(InterviewQuestion)
